import React from 'react'
import { Link } from "react-router-dom";
import HomeOurBlog from '../home/HomeOurBlog';


const Blog = () => {
    return (
        <>

            <section className="section-breadcrumb main-wrapper" style={{ overflow: "hidden" }}>
                <div className="breadcrumb-area">
                    <div className="container">
                        <div className="breadcrumb-wrapper">
                            <nav className="breadcrumb">
                                <Link className="breadcrumb-item" to="/">Home</Link>
                                <span className="breadcrumb-item active" aria-current="page">Our Blog</span>
                            </nav>
                            <h1 className="breadcrumb-title">Our Blog</h1>
                        </div>
                        <div className="breadcrumb-bg-block">
                            <img src="assets/images/breadcrumb-bg.jpg" alt="breadcrumb-bg" width={1920} height={448} className="img-cover" />
                            <img src="assets/images/breadcrumb-shape.png" alt="breadcrumb-shape" width={1033} height={448} />
                        </div>
                    </div>
                </div>
            </section>
            <HomeOurBlog />



        </>
    )
}

export default Blog